export default __webpack_public_path__ + "static/media/history.30786ba3.svg";